import { memo } from "react";

import type { EntityAttributeChange } from "types/generated";

import { CHANGE_COLOR, CHANGE_PREFIX } from "../constants";
import { extractAttributeValue, getStructuredFormat } from "../helpers";
import RunCodeChangesPrefix from "../Prefix";
import RunCodeChangesStructuredRow from "../StructuredRow";
import RunCodeChangesValues from "../Values";
import styles from "./styles.module.css";

type RunCodeChangesRowProps = {
  name: string;
  item: EntityAttributeChange;
};

const RunCodeChangesRow = memo(({ name, item }: RunCodeChangesRowProps) => {
  const { type } = item.changeForPhase.metadata;
  const prefix = CHANGE_PREFIX[type] ?? "\u00a0";
  const color = CHANGE_COLOR[type];

  const before = extractAttributeValue(item.changeForPhase.before);
  const after = extractAttributeValue(item.changeForPhase.after);
  const { afterUnknown } = item.changeForPhase;

  const beforeString = before?.type === "string" ? String(before.value) : undefined;
  const afterString = after?.type === "string" ? String(after.value) : undefined;

  const structuredFormat = getStructuredFormat(beforeString) ?? getStructuredFormat(afterString);

  if (structuredFormat) {
    return (
      <RunCodeChangesStructuredRow
        name={name}
        prefix={prefix}
        color={color}
        format={structuredFormat}
        before={beforeString}
        after={afterString}
        afterUnknown={afterUnknown}
      />
    );
  }

  return (
    <>
      <span />
      <RunCodeChangesPrefix prefix={prefix} color={color} />
      <span className={styles.name}>{name ? `${name}:` : ""}</span>
      <span className={styles.values}>
        <RunCodeChangesValues
          type={type}
          before={before}
          after={after}
          afterUnknown={afterUnknown}
        />
      </span>
    </>
  );
});

RunCodeChangesRow.displayName = "RunCodeChangesRow";

export default RunCodeChangesRow;
